export default __webpack_public_path__ + "6aa824db07d5b8be709fdc1d7e0596fe.wav";